import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

import CustomSnackbar from "../components/custom_snackbar";
import { CUSTOMER_INFO } from "../const/mount_list";
import { updatePasswordRequest } from "../services/api";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

function UpdatePass(props) {
  const classes = useStyles();
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { setMountTarget, setSubtitle, accountId } = props;

  const handleUpdatePassword = () => {
    if (
      !(
        /^([a-zA-Z0-9]{8,15})$/.test(oldPassword) &&
        /^([a-zA-Z0-9]{8,15})$/.test(newPassword)
      )
    )
      return setError(
        "ログインパスワードは英数8桁以上16桁未満で入力してください。"
      );

    updatePasswordRequest(oldPassword, newPassword, accountId).done(json => {
      if (json.error_code) {
        return setError(json.view_message);
      }
      setOldPassword("");
      setNewPassword("");
      setSuccessMessage("パスワードが更新されました。");
    });
  };

  const onSuccessSnackbarClose = () => {
    setSuccessMessage("");
    setMountTarget(CUSTOMER_INFO);
  };

  const onErrorSnackbarClose = () => {
    setError("");
  };

  const handleChangePassword = event => {
    const {
      target: { name, value }
    } = event;

    switch (name) {
      case "oldPassword":
        if (/^([a-zA-Z0-9]{0,15})$/.test(value)) setOldPassword(value);
        break;
      case "newPassword":
        if (/^([a-zA-Z0-9]{0,15})$/.test(value)) setNewPassword(value);
        break;
      default:
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  useEffect(() => {
    setSubtitle("パスワード再設定画面");
  });

  return (
    <>
      <div style={{ marginTop: "40px" }}></div>
      <div class="row">
        <div class="col-xs-3" />
        <div class="col-xs-6">
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="oldPassword"
              label="現在のパスワード (英数8桁以上15桁以下)"
              type="password"
              id="oldPassword"
              value={oldPassword}
              onChange={handleChangePassword}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="newPassword"
              label="新しいパスワード (英数8桁以上15桁以下)"
              type={showPassword ? "text" : "password"}
              id="newPassword"
              value={newPassword}
              onChange={handleChangePassword}
            />
            <input
              id="password_view"
              type="checkbox"
              value={showPassword}
              onChange={handleClickShowPassword}
            />
            <label for="password_view">パスワードを表示する</label>

            <div style={{ marginTop: "40px" }}></div>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={handleUpdatePassword}
            >
              再設定
            </Button>
          </form>

          <CustomSnackbar
            snackMessage={error}
            onSnackbarClose={onErrorSnackbarClose}
          />
          <CustomSnackbar
            snackMessage={successMessage}
            onSnackbarClose={onSuccessSnackbarClose}
            snackType="SUCCESS"
          />
        </div>
      </div>
    </>
  );
}

export default UpdatePass;
